import { FILTER_KEY } from '../enums';

const FILTERS = Object.freeze({
  [FILTER_KEY.CATEGORY]: (products, filterValues) =>
    Object.keys(products).reduce((prod, productCategory) => {
      if (filterValues.includes(productCategory)) return { ...prod, [productCategory]: products[productCategory] };
      return prod;
    }, {}),
});

export const getFilterParamsFromUrlLocation = location => {
  if (!location) return {};
  const searchParams = new URLSearchParams(location.search);
  const filterParams = {};
  const validFilterKeys = Object.values(FILTER_KEY);
  searchParams.forEach((value, key) => {
    if (validFilterKeys.includes(key) && value) {
      filterParams[key] = value.split(',').map(x => x.trim());
    }
  });
  return filterParams;
};

const filterProducts = (products, filterParams) => {
  return Object.keys(filterParams).reduce(
    (prod, filterKey) => FILTERS[filterKey](prod, filterParams[filterKey]),
    products
  );
};

export default filterProducts;
